import React from "react";
import { Link, Typography } from "@mui/material";
import Image from "next/image";
import { FacebookShareButton, TwitterShareButton } from "react-share";
import Grid from "@mui/material/Unstable_Grid2";
import ShareIcon from "@mui/icons-material/Share";

type Props = {
	data: any;
};

export default function SocialShare({ data }: Props) {

	const currentUrl = typeof window !== "undefined" ? window.location.href : "";

	return (
		<Grid
			container
			spacing={2}
			justifyContent={{ xs: "left", md: "center" }}
			alignItems={{ xs: "center", md: "center" }}
			direction={{ xs: "row", md: "column" }}
			xs={12}
			sx={{
				// mt: { xs: "0px", md: "15px", lg: "20px" },
				mb: "10px",
				display: { md: "flex", },
				position: { md: "sticky", },
				top: { md: "0", },
				margin: "8px auto"
			}}
		>
			<Grid xs={2.5} sm={1.5} md={12} sx={{ textAlign: { xs: "left", lg: "center" }, display: { xs: "block", sm: "block", md: "block", lg: "block" } }}>
				<Typography
					className="txt-bold"
					sx={{
						textAlign: { xs: "center", md: "center"},
						fontSize: "18px",
						fontWeight: "bold",
						display: "inline-block"
					}}
				>
					SHARE
				</Typography>
			</Grid>
			<Grid xs={2} sm={1} md={12} sx={{ textAlign: "center" }}>
				<Link href="" target="_blank" rel="noopener" 
					style={{
						display: "inline-block"
					}}>
					<FacebookShareButton
						url={currentUrl}
						quote={data?.articleTitle}
						hashtag={
							data?.articleTagRelation
								? `#${[
									...data.articleTagRelation.map(
										(item: any) => item.articleTag.tagTitle
									),
									"maaboom",
								].join(" #")}`
								: "#maaboom"
						}
						// style={{
						// 	display: "flex",
						// 	alignItems: "center",
						// 	justifyContent: "center",
						// 	width: "100%",
						// 	height: "100%",
						// }}
					>
						<Image
							src={"/assets/images/icon/Facebook_Logo_Primary 1.png"}
							width={42}
							height={42}
							alt="Twitter Share Icon"
						/>
					</FacebookShareButton>
				</Link>
			</Grid>
			<Grid xs={2} sm={1} md={12} sx={{ textAlign: "center" }}>
				<Link href="" target="_blank" rel="noopener"
					style={{ 
						display: "inline-block"
					}}>
					<TwitterShareButton url={currentUrl}>
						<Image
							src={"/assets/images/icon/xshare.png"}
							width={42}
							height={42}
							alt="Twitter Share Icon"
						/>
					</TwitterShareButton>
				</Link>
			</Grid>
		</Grid>
	);
}
